<se-fe-page
  [seFeDataLoaded]="true"
  SeFeDataWidth="full"
  class="se-product-management add-product"
  id="se-product-management">
  <div seFePageHeader>
    <se-fe-header seFePageHeader seFeDataTitle="Commerce" size="750"></se-fe-header>
  </div>
  <div seFePageContent class="add-product__content">
    <se-fe-card class="add-product__card">
      <se-fe-grid>
        <se-fe-card-content>
          <se-fe-grid seFeGridOpts="center">
            <se-fe-grid-cell>
              <se-fe-empty-state seFeDataTitle="Sell products to your members with SportsEngine Commerce">
                <se-fe-icon
                  seFeEmptyStateIcon
                  seFeDataName="store_thin"
                  seFeDataSize="950"
                  seFeDataColor="default"
                  seFeDataAriaLabel="product management store icon"></se-fe-icon>

                <!-- @if (status === 'Pending') {
                  <p>
                    Your application is processing. You can visit your financial settings to view the status of your
                    application.
                  </p>
                  <se-fe-button seFeDataEmphasis="high" (click)="navToFinancials()">Visit financials</se-fe-button>
                } @else { -->
                <p>
                  Before you can start selling to your members, you need to set up financials. Financials in
                  SportsEngine HQ allows you to collect and track every payment online in one place.
                </p>
                <se-fe-button seFeDataEmphasis="high" (click)="navToFinancials()">Set up financials</se-fe-button>
                <!-- } -->
              </se-fe-empty-state>
            </se-fe-grid-cell>
          </se-fe-grid>
        </se-fe-card-content>
      </se-fe-grid>
    </se-fe-card>
  </div>
</se-fe-page>
